import useStoreState from 'hooks/useStoreState';

const useAuth = () => useStoreState((store) => store.user);

export default useAuth;
